/**
 * WordPress dependencies
 */
import { _x } from '@safe-wordpress/i18n';

/**
 * List of T-shirt abbreviations.
 *
 * When there are 5 font sizes or fewer, we assume that the font sizes are
 * ordered by size and show T-shirt labels.
 */
export const T_SHIRT_ABBREVIATIONS = [
	/* translators: S stands for 'small' and is a size label. */
	_x( 'S', 'text', 'nelio-ab-testing' ),
	/* translators: M stands for 'medium' and is a size label. */
	_x( 'M', 'text', 'nelio-ab-testing' ),
	/* translators: L stands for 'large' and is a size label. */
	_x( 'L', 'text', 'nelio-ab-testing' ),
	/* translators: XL stands for 'extra large' and is a size label. */
	_x( 'XL', 'text', 'nelio-ab-testing' ),
	/* translators: XXL stands for 'extra extra large' and is a size label. */
	_x( 'XXL', 'text', 'nelio-ab-testing' ),
];

/**
 * List of T-shirt names.
 *
 * When there are 5 font sizes or fewer, we assume that the font sizes are
 * ordered by size and show T-shirt labels.
 */
export const T_SHIRT_NAMES = [
	_x( 'Small', 'text', 'nelio-ab-testing' ),
	_x( 'Medium', 'text', 'nelio-ab-testing' ),
	_x( 'Large', 'text', 'nelio-ab-testing' ),
	_x( 'Extra Large', 'text', 'nelio-ab-testing' ),
	_x( 'Extra Extra Large', 'text', 'nelio-ab-testing' ),
];
